import { FormattedMessage } from "react-intl";
import { Heading } from "../heading";
import { Tagline } from "../tagline";

export const SectionHeader = ({ headingId, subheadingId }) => headingId && subheadingId && (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Heading>
        <FormattedMessage id={headingId} />
      </Heading>
      <Tagline>
        <FormattedMessage id={subheadingId} />
      </Tagline>
    </div>
  );